import { render } from "./tag_editor.vue?vue&type=template&id=19a3fba8"
import script from "./tag_editor.vue?vue&type=script&lang=js"
export * from "./tag_editor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
var __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__